import { Injectable } from '@angular/core';
import { PlanningHasEntity } from '../../classes/planning-has-entity.class';
import { UserPlanning } from '../../classes/user-planning';
import { Utils } from '../../utils.class';
import { ApiService } from '../api/api.service';
import { Features } from '../auth/features';
import { RealtimeService } from '../realtime/realtime.service';
import { WebsocketService } from '../websocket/websocket.service';

@Injectable({
    providedIn: 'root',
})
export class UserPlanningService extends RealtimeService<UserPlanning> {
    constructor(
        private apiService: ApiService,
        protected websocketService: WebsocketService
    ) {
        super(websocketService, Features.PlanningUserPlanning);
    }

    itemInDaterange(planning: UserPlanning, fromDate: Date, toDate: Date) {
        return (
            Utils.getTimeOrNull(planning.begindate) < Utils.getTimeOrNull(toDate) &&
            Utils.getTimeOrNull(planning.enddate) > Utils.getTimeOrNull(fromDate)
        );
    }

    saveUserPlanningProject(userPlanning: UserPlanning[], planningHas: PlanningHasEntity[]) {
        return this.apiService.postCall$<[UserPlanning[], PlanningHasEntity[]]>('user-planning/project', {
            userPlanning,
            planningHas,
        });
    }

    deleteUserPlanning(id: number) {
        return this.apiService.deleteCall$(`user-planning/${id}`);
    }
}
